import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowDown, ArrowUpRight } from "lucide-react";
import HeroFilm from "./HeroFilm";

const fade = (delay) => ({ initial: { opacity: 0, y: 18 }, animate: { opacity: 1, y: 0 }, transition: { delay, duration: 0.9, ease: "easeOut" } });

export default function HeroBoutique() {
  return (
    <section data-testid="hero-section" className="relative min-h-[100svh] overflow-hidden bg-obsidian text-ivory">
      <HeroFilm />
      <div className="absolute inset-0 bg-gradient-to-b from-obsidian/75 via-obsidian/15 to-obsidian/95" />

      <div className="relative md:absolute md:inset-x-0 md:bottom-[15%] max-w-[1500px] mx-auto px-6 lg:px-14 pt-40 md:pt-0 text-center z-10">
        <motion.p {...fade(0.1)} data-testid="hero-eyebrow" className="text-[10px] md:text-xs tracking-[0.5em] uppercase text-ivory/65">
          <Link to="/about" data-testid="hero-founder-link" className="hover:text-gold-light transition-colors">Founded by Dewan Ali</Link>
        </motion.p>
        <motion.h1 {...fade(0.3)} className="mt-4 font-serif text-[10vw] md:text-[4vw] leading-[0.95] tracking-tight drop-shadow-[0_10px_40px_rgba(0,0,0,0.85)]">
          The House of <span className="italic gold-text">Around The World</span>
        </motion.h1>
        <motion.div {...fade(0.6)} className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/shop" data-testid="hero-shop-button" className="gold-button px-8 py-4 text-[10px] tracking-[0.25em] uppercase font-medium"><span className="relative z-10">Enter the store</span></Link>
          <Link to="/lookbook" data-testid="hero-bestsellers-button" className="glass-dark px-6 py-4 text-[10px] tracking-[0.25em] uppercase flex items-center gap-2 hover:border-gold/60 transition-colors">Lookbook <ArrowUpRight size={13} /></Link>
        </motion.div>
      </div>

      <motion.div {...fade(1)} className="hidden md:flex absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-2 text-ivory/45 z-10">
        <span className="text-[9px] tracking-[0.4em] uppercase">Walk in</span>
        <motion.span animate={{ y: [0, 7, 0] }} transition={{ repeat: Infinity, duration: 1.8, ease: "easeInOut" }}><ArrowDown size={15} strokeWidth={1.5} /></motion.span>
      </motion.div>
    </section>
  );
}
